module.exports = __webpack_public_path__ + "img/venx-logo-opacity.a59e6a15.svg";